
import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Layout, Form, Modal as antmodal, Divider, Button } from 'antd';
import { theme, Text, Tabs, Modal } from '@pfmam/pfmam';
import { Container, Box, Banner } from '../styles/globalStyle';
import AppLayout from '../common/layouts/appLayout';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Prompt } from 'react-router';
import EditWireInstructionsComponent from './components/editWireInstructionsComponent';
import EditWireInstructionsAccountPermissionsComponent from '../wireInstructions/components/editWireInstructionsAccountPermissionComponent';
import {
  GetWireAccountsPermissionsGridData,
  GetWirePayeeInstructionsDetails,
  TotalWireAccountsCount,
  GetStatesWithDescription,
  UpdateWirePayeeInstruction,
  TotalActiveWireAccounts,
  DeleteWirePayeeInstruction,
  WirePayeeInstructionPendingTransCount
} from '../actions/actions';
import LoadSpinner from '../common/components/LoadingSpinner/LoadSpinner';
import { CloseCircleOutlined } from '@ant-design/icons';
const { Content } = Layout;

export const OverrideStyles = createGlobalStyle`
  .ant-modal-footer {
    border-top:none;
  }
  .ant-modal-confirm .ant-modal-confirm-btns {
    float: none;
    display: flex;
    justify-content: center;
  }
  .helpful-dropdown-menu {
    .ant-dropdown-menu {
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
        0px 6px 16px rgba(0, 0, 0, 0.08);
      border-radius: 2px;
      padding: 4px 0;
      .ant-dropdown-menu-item {
        font-size: ${theme.font_size.size_l};
        line-height: 20px;
        color: ${theme.colors.black_secondary};
        padding: 8px 12px;
        &:hover {
          background: ${theme.colors.light_grey};
        }
        .anticon {
          margin-right: 8px;
        }
      }
      .
    }
  }
  .rc-virtual-list-scrollbar-thumb {
    background: rgb(0, 0, 0, 0.2) !important;
  }
  .profile-card {
    border-color: ${theme.colors.transparent} !important;
    .ant-card-head {
      padding: 0 32px;
      border-color: ${theme.colors.grey_fossil};
    }
    .ant-card-head-title {
      font-size: ${theme.font_size.size_3xl};
      line-height: 32px;
      padding: 24px 0;
    }
    .ant-card-body {
      padding: 32px;
    }
  }
  .statement-dropdown {
    width: 210px !important;
    .ant-dropdown-menu {
      padding: 0;
      box-shadow: ${theme.shadows.dropdown};
    }
    .ant-select-item {
      font-weight: normal;
      font-size: ${theme.font_size.size_l};
      color: ${theme.colors.black_secondary};
      line-height: 20px;
      padding: 8px 12px;
      &:hover {
        background: ${theme.colors.light_grey} !important;
      }
      &.ant-select-item-option-active,
      &.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
        :not(.ant-select-item-option-disabled) {
          background: ${theme.colors.transparent};
        }
      }
    }
  }
`;

const ContentWrapper = styled(Content)`
  .ant-table {
    border-radius: 4px;
    .ant-table-tbody {
      & > tr {
        cursor: pointer;
        &:hover {
          &.ant-table-row:not(.ant-table-expanded-row) {
            background: linear-gradient(
                0deg,
                rgba(23, 54, 93, 0.07),
                rgba(23, 54, 93, 0.07)
              ),
              ${theme.colors.white};
          }
        }
        & > td {
          vertical-align: top;
          padding: 20px 32px;
          &.ant-table-column-sort {
            background: ${theme.colors.transparent};
          }
        }
        &:last-child {
          & > td {
            border-bottom-color: ${theme.colors.transparent};
          }
        }
      }
    }
    .ant-table-thead {
      & > tr {
        & > th {
          background: ${theme.colors.light_grey};
          font-family: 'Inter';
          padding: 0 32px;
          font-weight: normal;
          line-height: 20px;
          &:not(:last-child) {
            &:not(.ant-table-selection-column) {
              &:not(.ant-table-row-expand-icon-cell) {
                &:not([colspan]) {
                  &::before {
                    background-color: ${theme.colors.transparent};
                  }
                }
              }
            }
          }
        }
      }
    }
    &.ant-table.ant-table-middle {
      .ant-table-thead {
        .ant-table-column-sorters {
          padding: 0;
          .ant-table-column-sorter-inner .anticon {
            color: ${theme.colors.grey_stone};
          }
          .ant-table-column-sorter-up.active,
          .ant-table-column-sorter-down.active {
            color: ${theme.colors.black_sorted};
          }
        }
        .ant-table-column-sorter-inner {
          margin-top: 0;
        }
      }
    }
    .sort-space-none {
      .ant-table-column-sorters {
        justify-content: flex-start;
      }
      .ant-table-column-title {
        flex: 0 0 auto;
      }
      &.flex-end {
        .ant-table-column-sorters {
          justify-content: flex-end;
        }
      }
    }
    .ant-avatar {
      min-width: 40px;
    }
  }
  .ant-table-title {
    padding: 0 !important;
  }
  .ant-table {
    &.ant-table-middle {
      .ant-table-tbody {
        .ant-table-wrapper {
          &:only-child {
            .ant-table {
              margin: -19px -32px;
            }
          }
        }
        .ant-table-container {
          .ant-table-tbody {
            .ant-table-row {
              .ant-table-cell {
                padding: 20px 32px;
                background-color: ${theme.colors.grey_faint};
              }
              &:hover {
                .ant-table-cell {
                  background-color: transparent;
                }
              }
            }
          }
        }
      }
    }
  }
`;

const EditWireInstructionsContainer = (props) => {
  if (!props?.location?.state?.canNavigateInstruction) {
    history.push("/404");
  }
  const history = useHistory();
  const [form] = Form.useForm();
  const connectLoggedInContactId = useSelector((state) => state.userSlice.user.profile.sub);
  const clientDetails = useSelector((state) => state.programsClientsSlice.selectedClient);
  const ssnorTIN = clientDetails.payload[0].ssnortin;
  const programId = clientDetails.payload[0].programid;
  const primary_color = useSelector((state) => state.siteInfo.primaryColor);
  const loggedInWebUserKey = useSelector((state) => state.userSlice.user.profile.name);
  const [isTouched, setIsTouched] = useState(false);
  const [loading, setloading] = useState(true);

  const wireInstructionsID = props.location.state.wireInstructionID;

  const [accountPermisionsInitialState, setAccountPermissionsInitialState] = useState(null);
  const [accountPermisionsDataSource, setAccountPermissionsDataSource] = useState(null);
  const [wireDetailsInitialValue, setWireDetailsInitialValue] = useState(null);
  const [wireDetailsDataSource, setWireDetailsDataSource] = useState(null);
  const [permissionsModalVisible, setPermissionsModalVisible] = useState(false);
  const [formDisabled, setFormDisabled] = useState(false);
  const [canSubmitInstruction, setCanSubmitInstruction] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitConfirmation, setIsSubmitConfirmation] = useState(false);
  const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
  const [isBankAccNumbDisabled, setIsBankAccNumbDisabled] = useState(false);
  const [isBeneNameDisabled, setIsBeneNameDisabled] = useState(false);
  const [initialTotalWireAccountsCount, setInitialTotalWireAccountsCount] = useState(0);
  const [initialTotalWireAccounts, setInitialTotalWireAccounts] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [promptEnabled, setPromptEnabled] = useState(true);
  const [onlyNickNameOrBeneDetailsChanged, setOnlyNickNameOrBeneDetailsChanged] = useState(false);
  const [isPendingTranactionPresent, setIsPendingTranactionPresent] = useState(false);
  const [hasWireDetailsChanged, setHasWireDetailsChanged] = useState(false);
  const [hasAccountPermissionChanged, setHasAccountPermissionChanged] = useState(false);

  useEffect(() => {

    GetWirePayeeInstructionsDetails(wireInstructionsID).then((response) => {
      if (response.data.length > 0) {
        setWireDetailsInitialValue(response.data[0]);
        setWireDetailsDataSource(response.data[0]);
        setSelectedState(response.data[0].BankState);
        form.setFieldsValue(response.data[0]);
        if (response.data[0].Status == 0 && loggedInWebUserKey.toUpperCase() !== response.data[0].CreatedBy.toUpperCase()) {
          setFormDisabled(true);
        }
        if (response.data[0].BankAccountNumber !== null && response.data[0].BankAccountNumber !== '') {
          setIsBankAccNumbDisabled(true);
        }
        if (response.data[0].BeneName !== null && response.data[0].BeneName !== '') {
          setIsBeneNameDisabled(true);
        }
        setloading(false);
      }
    }).catch((err) => {
      handleError(err);
    });

    GetWireAccountsPermissionsGridData(wireInstructionsID, connectLoggedInContactId, ssnorTIN, programId).then((response) => {
      if (response.data.Table.length > 0) {
        setAccountPermissionsInitialState(response.data.Table);
        setAccountPermissionsDataSource(response.data.Table);
        setloading(false);
      }
    }).catch((err) => {
      handleError(err);
    });

    TotalWireAccountsCount(wireInstructionsID, ssnorTIN, programId).then((response) => {
      setInitialTotalWireAccountsCount(response.data);
    }).catch((err) => {
      handleError(err);
    });

    TotalActiveWireAccounts(wireInstructionsID, ssnorTIN).then((response) => {
      setInitialTotalWireAccounts(response.data);
    }).catch((err) => {
      handleError(err);
    });

    GetStatesWithDescription().then((response) => {
      const stateList = [];
      if (response.data != null && response.data.length > 0) {
        response.data.map((val) => {
          const option = {};
          option.label = val.Code;
          option.value = val.Code;
          stateList.push(option);
        });
        setStates(stateList);
      }
    }).catch((err) => {
      handleError(err);
    });

  }, []);

  const beneLengthExceedOk = () => {
    setPromptEnabled(true);
    setSubmitted(false);
  };

  const deleteInstructionModalOk = () => {
    DeleteWirePayeeInstruction(wireInstructionsID).then((response) => {
      if (response.data) {
        setIsDeleteConfirmation(true);
        setSubmitted(false);
      }
    }).catch((err) => {
      handleError(err);
    });
    setSubmitted(false);
  }

  const deleteInstructionModalCancel = () => {
    setPromptEnabled(true);
    setSubmitted(false);
  }


  const UpdateWirePayeeInstructions = (wireDetails, hasAccountPermissionChanged, hasWireDetailsChanged, updatePendingTransactions) => {
    UpdateWirePayeeInstruction(wireDetails, accountPermisionsDataSource, ssnorTIN, hasAccountPermissionChanged, hasWireDetailsChanged, updatePendingTransactions).then((response) => {
      if (response.data) {
        setIsSubmitConfirmation(true);
        setSubmitted(false);
      }
    }).catch((err) => {
      setSubmitted(false);
      handleError(err);
    });
  }

  const onSubmit = () => {
    setPromptEnabled(false);
    setSubmitted(true);
    var localHasWireDetailsChanged = false;
    var localHasAccountPermissionChanged = false;

    const wireDetails = form.getFieldsValue();

    //There is a possibility that user might inspect element and delete the disabled property from submit button. So this is second check to stop user from submitting the instruction
    if (formDisabled || (initialTotalWireAccountsCount == 0 ? canSubmitInstruction ? false : true : false)) {
      antmodal.warning({
        title: formDisabled ? 'Cannot submit the instruction as it is in pending state!' : 'At least one account should be associated with the Wire Instruction!',
        okText: 'Ok',
        onOk: beneLengthExceedOk
      });
    } else {
      if ((wireDetails.BeneName != null ? wireDetails.BeneName.length : 0) + (wireDetails.BeneAccountNumber != null ? wireDetails.BeneAccountNumber.length : 0) + (wireDetails.BeneDetails != null ? wireDetails.BeneDetails.length : 0) > 140) {
        antmodal.warning({
          title: 'Wire File cannot support Beneficiary Information of more than 140 Characters!',
          okText: 'Ok',
          onOk: beneLengthExceedOk
        });
      } else {
        if (Object.keys(wireDetails).some(key => (wireDetails[key] !== null ? wireDetails[key] : '') !== (wireDetailsInitialValue[key] !== null ? wireDetailsInitialValue[key] : ''))) {
          localHasWireDetailsChanged = true;
          setHasWireDetailsChanged(true);
        }

        if (JSON.stringify(accountPermisionsDataSource) !== JSON.stringify(accountPermisionsInitialState)) {
          localHasAccountPermissionChanged = true;
          setHasAccountPermissionChanged(true);
        }

        //Check if only NickName or BeneDetails has changed. If yes then it won't go for pending approval. So we will have to display a seperate message on success of the submit.
        if (wireDetails.Status == 1 && localHasWireDetailsChanged && !localHasAccountPermissionChanged) {
          if (wireDetails.BankName == wireDetailsInitialValue.BankName
            && wireDetails.BankCity == wireDetailsInitialValue.BankCity
            && wireDetails.BankState == wireDetailsInitialValue.BankState
            && wireDetails.BankAccountNumber == wireDetailsInitialValue.BankAccountNumber
            && wireDetails.BeneName == wireDetailsInitialValue.BeneName
            && wireDetails.BeneAccountNumber == wireDetailsInitialValue.BeneAccountNumber
          ) {
            if (wireDetails.NickName?.toUpperCase() != wireDetailsInitialValue.NickName?.toUpperCase() || wireDetails.BeneDetails?.toUpperCase() != wireDetailsInitialValue.BeneDetails?.toUpperCase()) {
              setOnlyNickNameOrBeneDetailsChanged(true);
            }
          }
        }

        //Check if all the account permissions are removed. If yes then we will have to delete the wire instructions.
        var atleastOneAccountWireInstructionExist = accountPermisionsDataSource.some(items => items.HasAccess == 1);
        if (!atleastOneAccountWireInstructionExist) {
          //Below returns the accounts that are linked to the wire but not shown in connect.
          var val = findExtraAccounts(accountPermisionsDataSource, initialTotalWireAccounts);

          if (val.length == 0) {
            const mmodal = antmodal.confirm({
              maskStyle: ({
                backgroundColor: `${theme.rgba.modal}`,
                zIndex: '1051',
              }),
              width: (590),
              centered: true,
              icon: null,
              title:
                (
                  <p>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: "24px" }} >Wire Account Removal
                        <br />
                        <p style={{ fontStyle: "italic", fontSize: "14px", lineHeight: "20px", whiteSpace: "normal" }}>Upon submission, this account will no longer be available for any team member.</p>
                      </span>
                      <CloseCircleOutlined
                        style={{ cursor: 'pointer', fontSize: '24px' }}
                        onClick={() => {
                          deleteInstructionModalCancel();
                          mmodal.destroy();
                        }
                        }
                      />
                    </div>
                  </p>
                ),
              content:
                (
                  <>
                    <Divider style={{ borderColor: 'lightGray', margin: '8px 0' }} />
                    <p style={{ fontSize: "14px" }}>To continue with removal, select Confirm. To keep the wire account linked, select Cancel.</p>
                  </>
                ),
              okText: 'Confirm',
              cancelText: 'Cancel',
              onOk: deleteInstructionModalOk,
              onCancel: deleteInstructionModalCancel
            });
          } else {
            atleastOneAccountWireInstructionExist = true;
          }
        }

        if (atleastOneAccountWireInstructionExist) {
          if (wireDetails.Status != 0) {
            //Check if existing wire instruction has any pending transactions associated.
            WirePayeeInstructionPendingTransCount(wireInstructionsID).then((response) => {
              if (response.data > 0) {
                setIsPendingTranactionPresent(true);
              } else {
                UpdateWirePayeeInstructions(wireDetails, localHasAccountPermissionChanged, localHasWireDetailsChanged, false);
              }
            }).catch((err) => {
              handleError(err);
            });
          } else {
            UpdateWirePayeeInstructions(wireDetails, localHasAccountPermissionChanged, localHasWireDetailsChanged, false);
          }
        }

      }
    }
  };

  const findExtraAccounts = (arr1, arr2) => {
    const accountids1 = new Set(arr1.map(item => item.AccountUniqueID));
    return arr2.filter(item => !accountids1.has(item.AccountUniqueID));
  }

  const handleError = (err) => {
    console.log(err);
    antmodal.warning({
      title: 'There was an error processing the request. Please try again.',
      okText: 'Ok',
      onOk: () => {
        history.push("/dashboard");
      },
    });
  };

  const OnAccountsPermissionsOkClick = () => {
    var canSubmitInstruction = false;
    accountPermisionsDataSource.map(items => {
      if (items.HasAccess === 1) {
        canSubmitInstruction = true;
      }
    });

    setCanSubmitInstruction(canSubmitInstruction);
    setPermissionsModalVisible(false);
  };

  const OnAccountsPermissionsCancelClick = () => {
    setCanSubmitInstruction(false);
    setAccountPermissionsDataSource(accountPermisionsInitialState);
    setPermissionsModalVisible(false);
  };

  const handleConfirmationModalCancel = (value) => {
    if (value == 'pending' || value == 'nonpending')
      setIsSubmitConfirmation(false);
    if (value == 'deleted')
      setIsDeleteConfirmation(false);

    //navigate to Team Members screen.
    history.push("/settings", { showWirePayeeInformation: true });
  };

  const handlePendingTransModalCancel = (e) => {
    setIsPendingTranactionPresent(false);
    if (e?.currentTarget?.className?.includes('ant-modal-close')) {
      setPromptEnabled(true);
      setSubmitted(false);
    } else {
      UpdateWirePayeeInstructions(form.getFieldsValue(), hasAccountPermissionChanged, hasWireDetailsChanged, 'false')
    }
  };

  const handlePendingTransModalConfirm = (e) => {
    setIsPendingTranactionPresent(false);
    UpdateWirePayeeInstructions(form.getFieldsValue(), hasAccountPermissionChanged, hasWireDetailsChanged, 'true');
  };


  return (
    <AppLayout>
      <Prompt
        when={isTouched && promptEnabled}
        message={JSON.stringify({
          header: 'Discard Changes?',
          content:
            'Changes have not been submitted, leaving this page will result in no change of wire instruction or account permissions. Are you sure you want to leave this page?',
        })}
      />
      <OverrideStyles />
      <ContentWrapper>
        <Banner bgcolor={primary_color} height="124px">
          <Box
            display="flex"
            alignitems="center"
            height="100%"
            minwidth="100%"
            width="100%"
            zindex="3"
            position="relative"
            padding="44px 0 36px 0"
          >
            <Container>
              <Box
                display="flex"
                justifycontent="space-between"
                alignitems="flex-start"
                margin="0"
              >
                <Box flex="1">
                  <Text
                    color={`${theme.colors.white}`}
                    fontSize="36px"
                    lineheight="44px"
                    label="Wire Account"
                  />
                </Box>
              </Box>
            </Container>
          </Box>
        </Banner>
        <>
          {loading === false ? (
            <>
              <EditWireInstructionsComponent
                form={form}
                onSubmit={onSubmit}
                setPermissionsModalVisible={setPermissionsModalVisible}
                setIsTouched={setIsTouched}
                submitted={submitted}
                isBankAccNumbDisabled={isBankAccNumbDisabled}
                isBeneNameDisabled={isBeneNameDisabled}
                initialTotalWireAccountsCount={initialTotalWireAccountsCount}
                canSubmitInstruction={canSubmitInstruction}
                formDisabled={formDisabled}
                states={states}
                selectedState={selectedState}
              />

              <Modal
                // title="Permissions"
                //width="auto"
                style={{ minWidth: 800 }}
                onOk={() => setPermissionsModalVisible(!permissionsModalVisible)}
                bodyStyle={{
                }}
                maskStyle={{
                  backgroundColor: `${theme.rgba.modal}`,
                }}
                content={
                  <EditWireInstructionsAccountPermissionsComponent
                    accountPermisionsDataSource={accountPermisionsDataSource}
                    setAccountPermissionsDataSource={setAccountPermissionsDataSource}
                    OnAccountsPermissionsOkClick={OnAccountsPermissionsOkClick}
                    OnAccountsPermissionsCancelClick={OnAccountsPermissionsCancelClick}
                    formDisabled={formDisabled}
                    setIsTouched={setIsTouched}
                  />
                }
                visible={permissionsModalVisible}
                closable={false}
                footer={null}
                centered={true}
              />
            </>
          ) : (
            <LoadSpinner></LoadSpinner>
          )}
        </>
      </ContentWrapper>


      {isSubmitConfirmation && !onlyNickNameOrBeneDetailsChanged && (
        <Modal
          title=
          {
            <p>
              <div>
                <span>Linked Wire Account Changes Saved</span>
                <br />
                <p style={{ fontStyle: "italic", fontSize: "16px", lineHeight: "20px", whiteSpace: "normal" }}>Pending Approval</p>
              </div>
            </p>
          }
          width={590}
          bodyStyle={{
            padding: '10px 32px 34px 32px',
          }}
          maskStyle={{
            backgroundColor: `${theme.rgba.modal}`,
            zIndex: '1051',
          }}
          content={'Allow up to 48 hours for PFM Asset Management approval, at which time account will be available for use.'}
          visible={isSubmitConfirmation}
          onCancel={() => handleConfirmationModalCancel('pending')}
          okText={'Ok'}
          footer={null}
          centered={true}
          closable={true}
          cancelButtonProps={{ style: { display: 'none' } }}
          maskClosable={false}
        />

      )}

      {isDeleteConfirmation && (
        <Modal
          title={''}
          width={590}
          bodyStyle={{
            padding: '32px 32px 34px 32px',
          }}
          maskStyle={{
            backgroundColor: `${theme.rgba.modal}`,
            zIndex: '1051',
          }}
          content={'Instructions successfully removed and will no longer be available for use.'}
          visible={isDeleteConfirmation}
          onCancel={() => handleConfirmationModalCancel('deleted')}
          okText={'Ok'}
          footer={null}
          centered={true}
          closable={true}
          cancelButtonProps={{ style: { display: 'none' } }}
          maskClosable={false}
        />

      )}

      {isSubmitConfirmation && onlyNickNameOrBeneDetailsChanged && (
        <Modal
          title={''}
          width={590}
          bodyStyle={{
            padding: '32px 32px 34px 32px',
          }}
          maskStyle={{
            backgroundColor: `${theme.rgba.modal}`,
            zIndex: '1051',
          }}
          content={'Wire Account has been successfully updated and is now ready to use.'}
          visible={onlyNickNameOrBeneDetailsChanged}
          onCancel={() => handleConfirmationModalCancel('nonpending')}
          okText={'Ok'}
          footer={null}
          centered={true}
          closable={true}
          cancelButtonProps={{ style: { display: 'none' } }}
          maskClosable={false}
        />

      )}

      {isPendingTranactionPresent && (
        <Modal
          title=
          {
            <p>
              <div>
                <span>Pending Transaction(s)</span>
                <br />
                <p style={{ fontStyle: "italic", fontSize: "14px", lineHeight: "20px", whiteSpace: "normal" }}>There is at least one pending transaction that is utilizing this account.</p>
              </div>
            </p>
          }
          width={690}
          bodyStyle={{
            padding: '10px 32px 10px 32px',
          }}
          maskStyle={{
            backgroundColor: `${theme.rgba.modal}`,
            zIndex: '1051',
          }}
          content={
            <p>
              To update pending transaction(s) to reflect the entered change(s), select <strong>Update Account & Pending Transaction(s)</strong>.To not update pending transaction(s) with change(s), select <strong>Update Account</strong>.
            </p>
          }
          //content={'To update pending transaction(s) to reflect the entered change(s), select <strong>Update Account & Pending Transaction(s)</strong>.To not update pending transaction(s) with change(s), select <strong>Update Account</strong>.'}
          visible={isPendingTranactionPresent}
          onCancel={handlePendingTransModalCancel}
          onOk={handlePendingTransModalConfirm}
          centered={true}
          closable={true}
          cancelButtonProps={{ style: { display: 'none' } }}
          maskClosable={false}
          footer={
            <>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Button key='cancel' style={{ maxWidth: '190px', whiteSpace: 'nowrap', minHeight: '55px' }} onClick={handlePendingTransModalCancel}>Update Account</Button>
                <Button type="primary" style={{ maxWidth: '190px', whiteSpace: 'normal', minHeight: '55px' }} onClick={handlePendingTransModalConfirm} >Update Account & Pending Transaction(s)</Button>
              </div>
              <div style={{ textAlign: 'center', fontStyle: "italic", paddingTop: '10px',paddingLeft: '5px', paddingRight: '10px', fontSize: '12px', textAlign: 'justify' }}>
                Note: Update on pending transaction(s) does not change the account in which the transaction(s) is executed. The pending transaction(s) will be executed from the account selected upon entry.
              </div>
            </>

          }
        />
      )}
    </AppLayout>
  );
};

export default EditWireInstructionsContainer;